import { D_INV22G } from "constants/api/localStorage";

export function getUsername(): string | null {
  const data = localStorage.getItem(D_INV22G);

  if (data) {
    const parsedData = JSON.parse(data);

    return parsedData.usager;
  }
  return null;
}
